import { Box, BoxProps, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import { InfoIcon } from "..";
import VeriTooltip from "../VeriTooltip";
import { importedInvestmentWaringText } from "./importedInvestmentWaringText";
import { removeTSRequiredPropsWarn } from "../../../utils/removeTSRequiredPropsWarn";

export interface ImportedTagProps {
  isImported?: boolean | null;
  containerProps?: BoxProps;
}

export const ImportedTag: React.FC<ImportedTagProps> = ({
  isImported,
  containerProps,
}) => {
  const [triggerRef, setTriggerRef] = useState(null);

  if (!isImported) {
    return null;
  }

  return (
    <>
      <Box
        mx={2}
        bg="bg.greyLight"
        color="text.greyDarker"
        borderRadius={"40px"}
        px={2}
        display={"inline-flex"}
        alignItems="center"
        {...containerProps}
        ref={setTriggerRef as never}
      >
        <InfoIcon mr={1} boxSize={3} />
        <Text textStyle="bodyXSBold">Imported</Text>
      </Box>

      <VeriTooltip
        trigger={triggerRef}
        label={importedInvestmentWaringText}
        {...removeTSRequiredPropsWarn}
      />
    </>
  );
};
